import tracker from '../../components/tracker/publish'
import Analytics from '../analytics/Analytics'

const eventTracker = (item) => {
  const topicType = item.type === 'discussion' ? 'conversation' : item.type
  const eventLabel = {
    Type: topicType,
    Position: 'Recommendations list',
    Link: item.url
  }

  Analytics.send('Homepage', 'Topic clicked', eventLabel)

  tracker.trackEvent('userevent', {
    type: 'Topic Clicked',
    topic_title: item.title,
    topic_url: item.url,
    topic_position: item.idx + 1, // to start index from 1 instead of 0, added +1
    topic_topic_type: topicType,
    click_source: 'Homepage recommendation'
  })
}

const ContentCurationItem = (props) => {
  const { url, title, icon, id } = props
  return (
    <li className='topic-curation__item'>
      <span> {icon} </span>
      <a data-topic-id={id} className='topic-curation__item-link link' onClick={() => eventTracker(props)} href={url}>{title}</a>
    </li>
  )
}

export default ContentCurationItem
